import { RiveAnimation } from "../../components/ui/RiveAnimation";

export const CarouselAnimation = () => (
  <div className="tw-pointer-events-none tw-z-20 tw-h-full tw-w-full tw-overflow-x-auto tw-overflow-y-visible min840:tw-mt-[-50px] min1040:tw-mt-[-100px]">
    <div className="tw-z-20 tw-flex tw-w-full tw-items-center tw-overflow-x-auto">
      <RiveAnimation
        src="/landing_page_assets/rive/04.riv"
        className="tw-z-20 tw-aspect-[1368/600] tw-h-full tw-w-full tw-shrink-0 tw-overflow-hidden"
        fallbackSrc="/landing_page_assets/home_page/img1.png"
        fallbackClassName="tw-z-20 tw-mt-[2em] tw-aspect-[1368/600] tw-h-full tw-w-full tw-shrink-0 tw-overflow-hidden"
      />
    </div>
  </div>
);
